import styled, { DefaultTheme } from 'styled-components';

import {
  BodyMedium,
  Caption,
} from '../Typography/Typography.styles';

type StyleProps = {
  $isError?: boolean;
  $isDisabled?: boolean;
  $noBorder?: boolean;
  theme: DefaultTheme;
};

export const StyledContainer = styled.div<StyleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.neutral[500]};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.medium};
`;

export const StyledTextarea = styled.textarea<StyleProps>`
  ${BodyMedium}
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 240px;
  margin: 0;
  border: 1px solid
    ${({
    $isError,
    theme,
  }) => ($isError ? theme.colors.semantic.danger[500] : theme.colors.neutral[300])};
  padding: 12px 16px;
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-family: var(--executive-website-regular-font-family);
  appearance: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral[500]};
    font-family: var(--executive-website-regular-font-family);
  }

  &:focus-visible {
    outline: 1px solid
      ${({
    $isError,
    theme,
  }) => ($isError ?
    theme.colors.semantic.danger[500] :
    theme.colors.neutral[300])};
  }
`;

export const StyledCharactersLimit = styled.span<{ $isError: boolean }>`
  ${Caption}
  position: absolute;
  right: 0;
  bottom: ${({ $isError }) => ($isError ? '24px' : '0')};
  display: block;
  height: fit-content;
  margin-right: 16px;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.neutral[600]};
`;
